import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { convertAmount, convertByte } from '@/utils/common';
import LiquidChart from '../LiquidChart';

function Charts({ storage }) {
  const ss = convertByte(storage.storageSize);
  const se = convertAmount(storage.entries);
  return (
    <Root>
      <LiquidChart title={`数据大小 ${ss.unit}`} value={storage.storageSize} format={ss.value} />
      <LiquidChart title={`数据条数 ${se.unit}`} value={storage.entries} format={se.value} />
      <LiquidChart title='Ledgers' value={storage.segments} />
    </Root>
  );
}

export default connect((state) => ({
  storage: state.topic.storage,
}))(Charts);

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
